import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Moment from 'react-moment';
import { Avatar, Badge } from 'antd';

import { getAvatarBgClass } from '../../data/config/utils';

export default class ProfileAvatar extends React.PureComponent {
  render() {
    const { title, title_class, timestamp, default_avatar_bg, avatar_bg_class, container_class, size, badge_dot, shape, status } = this.props;
    let avatar_bg = {};
    if (avatar_bg_class) {
      avatar_bg = title && default_avatar_bg ? {} : avatar_bg_class;
    } else {
      avatar_bg = title && default_avatar_bg ? {} : getAvatarBgClass(title);
    }
    return (
      <div className={`ori-flex-row ${container_class}`}>
        <div className="ori-r-mrgn-10">
          <Badge status={badge_dot ? status : null} dot={badge_dot}>
            <Avatar size={size} shape={shape} className={classNames("ori-uppercase ori-align-avatar-letter", { ...avatar_bg })}>{title ? title.charAt(0) : 'u'}</Avatar>
          </Badge>
        </div>
        <div className="ori-loader-line-height ori-flex-column ori-flex-jc">
          {
            title &&
            <p className={`ori-capitalize ${title_class}`}>{title}</p>
          }
          {
            timestamp &&
            <p className="ori-font-light ori-font-11">Last activity <Moment fromNow >{timestamp}</Moment></p>
          }
        </div>
      </div>
    );
  }
}

ProfileAvatar.propTypes = {
  title: PropTypes.string,
  title_class: PropTypes.string,
  timestamp: PropTypes.string,
  container_class: PropTypes.string,
  default_avatar_bg: PropTypes.bool,
  avatar_bg_class: PropTypes.object,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['large', 'small', 'default'])]),
  badge_dot: PropTypes.bool,
  shape: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['square', 'circle'])]),
  status: PropTypes.oneOf(['success', 'error', 'processing', 'warning']),
};

ProfileAvatar.defaultProps = {
  title_class: "ori-font-sm",
  default_avatar_bg: false,
  size: "default",
  badge_dot: false,
  shape: "circle",
  status: "success"
};



// WEBPACK FOOTER //
// ./src/components/profileavatar/index.js